module.exports = __webpack_public_path__ + "static/media/service-mob.5382ebe0.png";